export default __webpack_public_path__ + "static/media/Perth_GFloor_old.2d87c9f4.jpg";